<template>
  <el-scrollbar ref="scrollbar" class="page_main_height">
    <div class="big_screen" @click="videoShow = false">
      <div class="game_pc">
        <div class="game_pc_head">
          <div class="game_head_logo">
            <div class="game_head_logo_img">
              <img :src="phone.gameLogoUrl" alt="">
            </div>
            <div class="game_head_logo_txt">
              <div>不朽之旅</div>
              <div>自由BD 放置成神</div>
            </div>
          </div>

          <div class="game_pc_head_age">
            <img :src="ageImgUrl" alt="">
          </div>

          <img :src="pc.backgroundImg1" alt="">
        </div>

        <div class="game_pc_main">
          <div class="game_pc_main_video">
            <div class="game_pc_main_video_main" :style="'background-image: url(' + pc.gamePcMainVideo + '); background-size: 100% 100%; background-repeat: no-repeat;'" title="点击播放视频" @click="videoShow = !videoShow" @click.stop="">
              <div class="game_pc_main_video_bac" :style="'background-image: url(' + pc.gamePcMainVideoBacUrl + '); background-size: 100% 100%;'">
                <div class="game_pc_main_video_bac2" :style="'background-image: url(' + pc.gamePcMainVideoBacUrl2 + '); background-size: 100% 100%; background-repeat: no-repeat;'">
                  <div class="game_pc_main_video_bac3" :style="'background-image: url(' + pc.gamePcMainVideoBacUrl3 + '); background-repeat: no-repeat; background-size: 100% 100%;'" />
                </div>
              </div>
            </div>
          </div>

          <div class="game_pc_main_line">
            <img :src="pc.gameLineUrl" alt="">
          </div>

          <div class="game_pc_main_carousel">
            <el-carousel :autoplay="false" :interval="2000" type="card" height="3.125rem" class="game_pc_main_carousel_main">
              <el-carousel-item v-for="(item, index) in phone.carouselImgUrlList" :key="index" class="game_pc_main_carousel_main_item">
                <img :src="item" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>

          <div class="game_pc_main_code">
            <div class="game_pc_main_code_item game_main_code_wechat">
              <div class="game_pc_main_code_item_main">
                <img :src="phone.wechatCodeUrl" alt="">
                <div class="game_pc_main_code_item_txt">微信公众号</div>
              </div>
            </div>
            <div class="game_pc_main_code_item game_main_code_qq">
              <div class="game_pc_main_code_item_main">
                <img :src="phone.qqCodeUrl" alt="">
                <div class="game_pc_main_code_item_txt">官方QQ群</div>
              </div>
            </div>
          </div>
        </div>

        <div :class="videoShow ? 'video_show' : 'video_hidden'" class="bxzl_video_iframe">
          <iframe :src="videoUrl" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true" />
        </div>

        <div class="down_fixed">
          <div class="down_fixed_item down_fixed_taptap">
            <img :src="pc.taptapDownImgUrl" alt="">
          </div>
          <div class="down_fixed_item down_fixed_ios">
            <img :src="pc.iosDownImgUrl" alt="">
          </div>
        </div>
      </div>

      <index_bottom />
    </div>

    <div class="small_screen">
      <div class="game">
        <div class="game_head">
          <div class="game_head_logo">
            <div class="game_head_logo_img">
              <img :src="phone.gameLogoUrl" alt="">
            </div>
            <div class="game_head_logo_txt">
              <div>不朽之旅</div>
              <div>自由BD 放置成神</div>
            </div>
          </div>

          <div class="game_head_down">
            <div class="game_head_down_tap">
              <img :src="phone.taptapDownImgUrl" alt="">
            </div>
            <div class="game_head_down_ios">
              <img :src="phone.iosDownImgUrl" alt="">
            </div>
          </div>
        </div>

        <div class="game_main">
          <div class="game_main_img_1">
            <img :src="phone.gameImg1Url" alt="" class="game_main_img_1">
          </div>

          <div class="game_main_video">
            <div class="game_main_video_iframe">
              <iframe src="//player.bilibili.com/player.html?isOutside=true&aid=456973403&bvid=BV1G5411b7bZ&cid=820371002&p=1&autoplay=0" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true" />
            </div>
          </div>

          <div class="game_main_main">
            <div class="game_main_main_line">
              <img :src="phone.gameLineUrl" alt="">
            </div>

            <div class="game_main_carousel">
              <el-carousel :autoplay="false" type="card" height="6.04rem" class="game_main_carousel_main">
                <el-carousel-item v-for="(item, index) in phone.carouselImgUrlList" :key="index" class="game_main_carousel_main_item">
                  <img :src="item" alt="">
                </el-carousel-item>
              </el-carousel>
            </div>

            <div class="game_main_code">
              <div class="game_main_code_item game_main_code_wechat">
                <div>
                  <img :src="phone.wechatCodeUrl" alt="">
                  <div class="game_main_code_item_txt">微信公众号</div>
                </div>
              </div>
              <div class="game_main_code_item game_main_code_qq">
                <div>
                  <img :src="phone.qqCodeUrl" alt="">
                  <div class="game_main_code_item_txt">官方QQ群</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <index_bottom />
    </div>
  </el-scrollbar>
</template>

<script>
export default {
  name: 'Bxzl',
  data() {
    return {
      phone: {
        gameLogoUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/indexHead/1715682417961108x108-icon1.png',
        taptapDownImgUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/indexHead/1716947615377159963435336585503869343.png',
        iosDownImgUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/indexHead/1716947676918iosDown.png',
        gameImg1Url: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/indexHead/1716948773700bxzl1.jpg',
        gameVideoImgUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzlVideoImg.png',
        gameLineUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/indexHead/1716952393403bxzl2.png',
        carouselImgUrlList: [
          'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzl_carousel_1.jpg',
          'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzl_carousel_2.jpg',
          'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzl_carousel_3.jpg',
          'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzl_carousel_4.jpg'
        ],
        wechatCodeUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzl_wechat.jpg',
        qqCodeUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzl_qq.png'
      },
      pc: {
        backgroundImg1: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzl_pc_img_1.jpg',
        gamePcMainVideo: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzlVideoBac.png',
        gamePcMainVideoBacUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzlVideoImg.png',
        gamePcMainVideoBacUrl2: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzlVideoBac2.png',
        gamePcMainVideoBacUrl3: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/bxzlVideoBac3.png',
        gameLineUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/indexHead/1716952393403bxzl2.png',
        taptapDownImgUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/indexHead/1716947615377159963435336585503869343.png',
        iosDownImgUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/indexHead/1716947676918iosDown.png'
      },
      videoShow: false,
      videoUrl: '//player.bilibili.com/player.html?isOutside=true&aid=456973403&bvid=BV1G5411b7bZ&cid=820371002&p=1&autoplay=0',
      ageImgUrl: 'https://www.nemojoy.com/nemojoyWebSiteFile/imgs/games/bxzl/age.png'
    }
  },
  created() {
    document.title = '不朽之旅-九鱼乐官方平台'
  }
}
</script>

<style lang="scss">
body{
  background-color: #090504;
}

/*小于768px的显示*/
@media screen and (max-width: 768px){
  .big_screen{
    display: none!important;
  }

  .small_screen{
    display: block!important;

    .game{
      .game_head{
        width: 100%;
        background-color: #050507;
        display: flex;
        justify-content: space-between;
        position: fixed;
        top: 0;
        z-index: 6;

        .game_head_logo{
          padding: .1rem .13rem;
          display: flex;

          .game_head_logo_img {
            img{
              width: .52rem;
              height: .52rem;
              border-radius: .1rem;
            }
          }

          .game_head_logo_txt{
            margin-left: .1rem;

            div:first-child{
              color: #FFFFFF;
              font-size: .2rem;
            }

            div:last-child{
              color: #ceae95;
              font-size: .18rem;
            }
          }
        }

        .game_head_down{
          display: flex;
          align-items: center;
          margin-left: .1rem;

          div{
            margin-right: .1rem;

            img {
              width: 1.28rem;
              height: .39rem;
              border-radius: .05rem;
            }
          }
        }
      }

      .game_main{
        .game_main_img_1{
          img {
            width: 100vw;
          }
        }

        .game_main_video{
          width: 100%;
          height: auto;
          display: flex;
          justify-content: center;
          position: relative;

          .game_main_video_iframe{
            width: 3.9rem;
            height: 1.95rem;
            position: relative;
            top: -.9rem;

            iframe{
              width: 100%;
              height: 100%;
            }
          }
        }

        .game_main_main{
          width: 100%;
          position: relative;
          top: -.9rem;

          .game_main_main_line{
            width: 100%;

            img {
              width: 100%;
            }
          }

          .game_main_carousel{
            width: 100%;

            .game_main_carousel_main{
              width: 100%;

              .game_main_carousel_main_item{
                img {
                  width: 3.40rem;
                  height: 6.04rem;
                }
              }
            }
          }

          .game_main_code{
            width: 100%;
            display: flex;
            justify-content: space-around;
            margin-top: .5rem;

            .game_main_code_item{
              width: 1.43rem;
              height: 1.43rem;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-wrap: wrap;
              background-color: #C5AE8A;
              border-radius: .1rem;
              color: #FFFFFF;

              img {
                width: .78rem;
                height: .78rem;
              }

              .game_main_code_item_txt{
                display: flex;
                justify-content: center;
              }
            }
          }
        }
      }
    }
  }
}

/*大于768px的显示*/
@media screen and (min-width: 768px){
  .big_screen{
    background-color: #050507;
    display: block!important;

    .game_pc {
      .game_pc_head{
        img{
          width: 100%;
        }

        .game_head_logo{
          position: relative;
          top: .336rem;
          left: 0.270rem;
          display: flex;
          align-items: center;
          height: 0;

          .game_head_logo_img {
            img{
              width: .438rem;
              height: .438rem;
              border-radius: .1rem;
            }
          }

          .game_head_logo_txt{
            margin-left: .1rem;

            div:first-child{
              color: #FFFFFF;
              font-size: .125rem;
            }

            div:last-child{
              color: #ceae95;
              font-size: .083rem;
            }
          }
        }

        .game_pc_head_age{
          height: 0;

          img {
            position: relative;
            z-index: 6;
            right: 0;
            width: .364rem;
            height: .458rem;
          }
        }
      }

      .game_pc_main{
        .game_pc_main_video{
          width: 100%;
          height: 1.75rem;
          display: flex;
          justify-content: center;

          .game_pc_main_video_main{
            position: relative;
            top: -1rem;
            width: 3.75rem;
            height: 2.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            .game_pc_main_video_bac{
              width: 3.34rem;
              height: 2.082rem;
              display: flex;
              justify-content: center;
              align-items: center;

              .game_pc_main_video_bac2{
                width: .57rem;
                height: .57rem;
                display: flex;
                justify-content: center;
                align-items: center;

                .game_pc_main_video_bac3{
                  width: .195rem;
                  height: .195rem;
                }
              }
            }

            //.game_pc_main_video_iframe{
            //  width: 100%;
            //  display: flex;
            //  justify-content: center;
            //
            //  iframe{
            //    width: 3.167rem;
            //    height: 1.167rem;
            //  }
            //}
          }
        }

        .game_pc_main_line{
          width: 100%;
          display: flex;
          justify-content: center;
        }

        .game_pc_main_carousel{
          width: 100%;
          display: flex;
          justify-content: center;

          .game_pc_main_carousel_main{
            width: 5rem;

            .game_pc_main_carousel_main_item{
              display: flex;
              justify-content: center;

              img {
                width: 1.755rem;
                height: 3.125rem;
              }

              .el-carousel__mask{
                background-color: #090504;
              }
            }
          }
        }

        .game_pc_main_code{
          width: 100%;
          display: flex;
          justify-content: center;
          margin: .5rem 0 .3rem 0;

          .game_pc_main_code_item{
            width: 1.20rem;
            height: 1.20rem;
            border: .02rem solid #EBE2D3;
            border-radius: .04rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #F3EEEB;
            background-color: #171614;
            margin-right: .3rem;

            .game_pc_main_code_item_main{
              background-color: #3B3537;
              padding: .104rem .104rem 0 .104rem;

              img{
                width: .73rem;
                height: .73rem;
              }

              .game_pc_main_code_item_txt{
                display: flex;
                justify-content: center;
                font-size: .104rem;
                font-weight: bold;
              }
            }
          }
        }
      }

      .bxzl_video_iframe{
        width: 80vw;
        height: 45vw;
        position: absolute;
        left: 10vw;
        z-index: 101;
        margin-top: -22.5vw;

        iframe{
          width: 100%;
          height: 100%;
        }
      }

      .video_show{
        top: 50%;
        transition: top 1s;
      }

      .video_hidden{
        top: -130vw;
        transition: top 1s;
      }

      .down_fixed{
        background-color: rgba(12,7,6,0.3);
        padding: .156rem .13rem;
        position: fixed;
        right: 0;
        top: 50%;
        border-radius: .05rem;
        z-index: 6;

        .down_fixed_item{
          margin-bottom: .104rem;
          cursor: pointer;

          img {
            width: .85rem;
            height: .26rem;
            border-radius: .03rem;
          }
        }

        .down_fixed_item:last-child{
          margin-bottom: 0;
        }
      }
    }
  }

  .small_screen{
    display: none!important;
  }
}
</style>
